export function getEventPagePath(eventId: string): string {
  return `/events/${encodeURIComponent(eventId)}`;
}
